import { useLingui } from '@lingui/react/macro';
import { TimerIcon } from '@phosphor-icons/react';
import { Typography } from '@remarkable/ark-web';

import { formatDate } from 'src/utils/formatDate';

const useExpirationText = (expirationDateIsoString: string | null) => {
  const { t, i18n } = useLingui();
  if (!expirationDateIsoString) {
    return null;
  }

  const expirationDate = new Date(expirationDateIsoString);
  const currentDate = new Date();
  const diffTime = expirationDate.getTime() - currentDate.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  const formattedExpirationDate = formatDate(expirationDateIsoString, {
    locale: i18n.locale,
  });

  if (diffDays >= 30) {
    return t`Free trial available for ${diffDays} days`;
  } else if (diffDays > 0) {
    return t`Free trial available until ${formattedExpirationDate}`;
  } else {
    return null;
  }
};

export const ExpirationText = ({
  expirationDate,
}: {
  expirationDate: string | null;
}) => {
  const expirationText = useExpirationText(expirationDate);

  if (!expirationText) {
    return null;
  }

  return (
    <span className="flex flex-row items-center">
      <TimerIcon
        size={24}
        className="mr-8 inline-block shrink-0 text-pen-blue"
      />
      <Typography
        variant="interface-sm"
        fontWeight="medium"
        uppercase
        leadingNone
        className="inline-block text-pen-blue"
      >
        {expirationText}
      </Typography>
    </span>
  );
};
